
import jwtDecode from 'jwt-decode';
import axios from 'axios';

class Auth {
  /**
   * Authenticate a user. Save a token string in Local Storage
   *
   * @param {string} token
   */
  static authenticateUser(token) {
    const expiryDays = 30 * 24 * 60 * 60 * 1000;
    const date = new Date();
    date.setTime(date.getTime() + (expiryDays));
    document.cookie = `token=${token};expires=${date.toUTCString()};Path=/`;
  }

  /**
   * Check if a user is authenticated - check if a token is saved in Local Storage
   *
   * @returns {boolean}
   */
  static hasCookie() {
    return this.getCookie('token') !== null;
  }

  /**
   * Deauthenticate a user. Remove a token from Local Storage.
   *
   */
  static deauthenticateUser() {
    document.cookie = 'token=;expires=Thu, 01 Jan 1970 00:00:01 GMT;Path=/';
  }

  /**
   * Get a token value.
   *
   * @returns {string}
  */
  static getToken() {
    return this.getCookie('token');
  }

  static getUser() {
    return this.parseJwt(this.getCookie('token'));
  }

  static async user() {
    const token = this.getToken();
    let response = null;
    try {
      response = await axios.get('/api/auth/user', { headers: { token } });
    } catch (error) {
      // The token has expired or is not valid. CouchDB would refuse it too, so sign in again.
      // Pattern edits waiting in this browser are kept and sync after signing in.
      if (error.response && error.response.status === 401) {
        this.deauthenticateUser();
        window.location.href = '/app/login';
      }
      throw error;
    }

    return response.data.response.user || null;
  }

  static async getUserProfile() {
    const token = this.getToken();
    const response = axios.get('/api/user/get-profiles', { headers: { token } });
    return response.data.response.profiles || [];
  }

  /**
   * Get cookie Information
   * @param {string} cname cookie name
   */
  static getCookie(cname) {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i += 1) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }

  /**
   * get the token information
   * @param {string} token
   */
  static parseJwt(token) {
    return token ? jwtDecode(token) : null;
  }
}

export default Auth;
